import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  Icon,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  Switch,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  TextField,
  Typography,
} from '@mui/material';
import PageContainer from '../../components/container/PageContainer';
import Breadcrumb from '../../layouts/full-layout/breadcrumb/Breadcrumb';
import {
  filterAllCmdFournisseur,
  listCmdExpedition,
  receptionnerManyCmd,
  searchCmdPublicByRef,
  updateCmdMultiStatus,
  viewCmdFournisseur,
} from '../../redux/slices/commande-fournisseur.slice';
import {
  cmd_type_bg,
  CmdFbStatusBg,
  CmdFbStatusDelaisAccumul,
  CmdFournisseurStatus,
} from '../../utils/commande.enums';
import dayjs from 'dayjs';
import WhatshotIcon from '@mui/icons-material/Whatshot';
import CmdFbDetailsWidget from './CmdFbDetails.widget.js';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import { useQrCameraScanner } from '../../hooks/useQrCameraScanner.js';
import { ScanFeedbackToast, useHardwareQrScanner } from '../../hooks/useHardwareQrScannerV2.js';

const BCrumb = [
  {
    to: '/App',
    title: 'Home',
  },
  {
    title: 'Edit en lots',
  },
];
const BCrumb_pickup = [
  {
    to: '/App',
    title: 'Home',
  },
  {
    title: 'Réception',
  },
];

const allowed_status = [
  CmdFournisseurStatus.A_SAISIR,
  CmdFournisseurStatus.EN_ETIQUETAGE,
  CmdFournisseurStatus.A_DISPATCHER_MG,
  CmdFournisseurStatus.ENVOYE_MG,
  CmdFournisseurStatus.EN_STOCK,
  CmdFournisseurStatus.PRETE,
  CmdFournisseurStatus.A_EXPEDIE,
  CmdFournisseurStatus.LIVRE,
];

const allowed_status_pickup = [CmdFournisseurStatus.ENVOYE_MG];

const CmdBulkEditContainer = ({ pickup_mode }) => {
  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.cmd_achat_store);
  const [lst_cmd, set_lst_cmd] = useState([]);
  const [lst_cmd_serach, set_lst_cmd_serach] = useState([]);
  const [sel_item, set_sel_item] = useState(null);
  const [show_details, set_show_details] = useState(false);
  const [sel_status, set_sel_status] = useState('');

  const onSearchCommande = (event, value, reason) => {
    dispatch(searchCmdPublicByRef(value))
      .unwrap()
      .then((res) => {
        if (Array.isArray(res)) {
          if (pickup_mode)
            set_lst_cmd_serach(res.filter((el) => allowed_status_pickup.includes(el?.status)));
          else set_lst_cmd_serach(res.filter((el) => allowed_status.includes(el?.status)));

          if (sel_item) {
            set_sel_item(res.find((el) => el?.ref == sel_item?.ref));
          }
        }
      })
      .catch((err) => console.log(err));
  };

  const onAddCmd = (value) => {
    if (value) set_lst_cmd([value, ...lst_cmd]);
  };
  const onDelCmd = (value) => {
    if (value) set_lst_cmd(lst_cmd.filter((el) => el?.idCmdFournisseur != value));
  };

  const onUpdateMultiStatus = () => {
    if (pickup_mode && lst_cmd?.length)
      dispatch(
        receptionnerManyCmd({
          ids: lst_cmd.map((el) => el?.idCmdFournisseur),
        }),
      )
        .unwrap()
        .then((res) => {
          set_lst_cmd([]);
          set_lst_cmd_serach([]);
        })
        .catch((err) => console.log(err));
    else if (lst_cmd?.length && sel_status)
      dispatch(
        updateCmdMultiStatus({
          ids: lst_cmd.map((el) => el?.idCmdFournisseur),
          status: sel_status,
        }),
      )
        .unwrap()
        .then((res) => {
          set_lst_cmd([]);
          set_lst_cmd_serach([]);
        })
        .catch((err) => console.log(err));
  };

  const onShowDetails = (data) => {
    set_sel_item(data);
    set_show_details(true);
  };
  const onCloseDetails = () => {
    set_sel_item(null);
    set_show_details(false);
  };

  const { openScanner, QrScannerModal, closeScanner } = useQrCameraScanner({
    onScan: (value) => {
      const data = JSON.parse(value);
      console.log(data);
      if (data?.type === 'bon-commande' && data?.id) {
        dispatch(viewCmdFournisseur(data?.id))
          .unwrap()
          .then((res) => {
            if (pickup_mode && allowed_status_pickup.includes(res?.status)) onAddCmd(res);
            else if (allowed_status.includes(res?.status) && !pickup_mode) onAddCmd(res);

            //onAddCmd(res);
            closeScanner();
          })
          .catch((err) => console.log(err));
      }
    },
  });

  const handleScan = (value) => {
    console.log(value);
    const data = JSON.parse(value);
    console.log(data);
    if (data?.type === 'bon-commande' && data?.id) {
      dispatch(viewCmdFournisseur(data?.id))
        .unwrap()
        .then((res) => {
          if (pickup_mode && allowed_status_pickup.includes(res?.status)) onAddCmd(res);
          else if (allowed_status.includes(res?.status) && !pickup_mode) onAddCmd(res);
          closeScanner();
        })
        .catch((err) => console.log(err));
    }
  };

  // const scanner = useHardwareQrScanner({ onScan: handleScan });

  const { lastScan } = useHardwareQrScanner(
    (data, raw) => {
      if (!data) {
        console.warn('Malformed scan:', raw);
        return;
      }
      console.log(data?.type, data?.id); // "bon-commande" 23569
      handleScan(data);
    },
    { parseJson: true },
  );

  return (
    <PageContainer title="Réception des commandes" description="">
      {/* breadcrumb */}
      <Breadcrumb
        title={pickup_mode ? 'Réception des commandes' : 'Modifier par lots'}
        items={pickup_mode ? BCrumb_pickup : BCrumb}
      />
      {/* end breadcrumb */}

      {/* Search Bar  */}

      <Box>
        <Autocomplete
          options={Array.isArray(lst_cmd_serach) ? lst_cmd_serach : []}
          getOptionLabel={(el) =>
            el
              ? `${el?.ref} - ${
                  el?.client
                    ? `${el?.client?.nom} ${el?.client?.prenom}`
                    : el?.fournisseur?.nomSociete
                }`
              : ''
          }
          loading={loading}
          onInputChange={onSearchCommande}
          onChange={(event, newValue) => {
            return onAddCmd(newValue);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              size="small"
              placeholder="Num Commande / client ..."
              aria-label="fb"
            />
          )}
        />
      </Box>

      <Box textAlign={'end'} sx={{ py: 2 }}>
        <Button
          size="small"
          onClick={openScanner}
          variant="outlined"
          color="primary"
          sx={{ mr: 1 }}
        >
          <FeatherIcon icon="camera" width="18" />
          <Typography sx={{ pl: 1 }}> Scanner QR (CAM)</Typography>
        </Button>
        <QrScannerModal />
        <ScanFeedbackToast scanner={lastScan} />
        {!pickup_mode && (
          <TextField
            size="small"
            select
            value={sel_status}
            onChange={(e) => set_sel_status(e?.target?.value)}
            label={'Status'}
            disabled={lst_cmd?.length == 0 || loading}
            sx={{ mr: 2, width: 240 }}
          >
            {allowed_status.map((el) => (
              <MenuItem key={`select-status-${el}`} value={el}>
                {el}
              </MenuItem>
            ))}
          </TextField>
        )}
        <Button
          onClick={onUpdateMultiStatus}
          disabled={lst_cmd?.length == 0 || loading}
          variant="outlined"
          color="success"
          sx={{ px: 3 }}
        >
          {pickup_mode ? 'Réceptionner' : 'Appliquer'}
        </Button>
      </Box>

      {/* List Form */}
      <CmdList
        loading={loading}
        error={error}
        lst_items={lst_cmd}
        onShowCmdDetails={onShowDetails}
        onUpdateMultiStatus={onUpdateMultiStatus}
        onDelItem={onDelCmd}
      />

      <CmdFbDetailsWidget
        idCmdFournisseur={sel_item?.idCmdFournisseur}
        show={show_details}
        onClose={onCloseDetails}
      />
    </PageContainer>
  );
};

const CmdList = ({ lst_items, loading, error, onShowCmdDetails, onDelItem }) => {
  return (
    <div style={{ marginTop: '20px' }}>
      <TableContainer>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Num Commande</TableCell>
              <TableCell>Article</TableCell>
              <TableCell>Client</TableCell>
              <TableCell>Fournisseur</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Date Prévu</TableCell>
              <TableCell>Magasin</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {lst_items.map((el) => (
              <CmdItem
                key={el?.idCmdFournisseur}
                cmd={el}
                onItemClick={onShowCmdDetails}
                onDelItem={onDelItem}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

const CmdItem = ({ cmd, onItemClick, onDelItem }) => {
  const [blocage_tags, set_blocage_tags] = useState([]);
  const [is_retard, set_is_retard] = useState(false);
  const [nbr_j_retard, set_nbr_j_retard] = useState(false);

  useEffect(() => {
    if (cmd?.is_urgent && cmd?.date_urgent) {
      let date_expected = dayjs(String(cmd?.date_urgent).substring(0, 10));
      if (date_expected.isBefore(dayjs(), 'day') && cmd?.status != CmdFournisseurStatus.LIVRE) {
        set_is_retard(true);
        set_nbr_j_retard(date_expected.diff(dayjs(), 'day'));
      }
    } else {
      let date_expected = dayjs(String(cmd?.date_livraison).substring(0, 10));
      let date_creation = dayjs(String(cmd?.created_at).substring(0, 10));
      if (date_expected.isBefore(dayjs(), 'day') && cmd?.status != CmdFournisseurStatus.LIVRE) {
        set_is_retard(true);
        set_nbr_j_retard(date_expected.diff(dayjs(), 'day'));
      } else {
        if (
          date_creation
            .add(+CmdFbStatusDelaisAccumul[cmd?.status] || 0, 'day')
            .isBefore(dayjs(), 'day')
        ) {
          set_is_retard(true);
          set_nbr_j_retard(
            date_creation
              .add(+CmdFbStatusDelaisAccumul[cmd?.status] || 0, 'day')
              .diff(dayjs(), 'day'),
          );
        }
      }
    }
  }, [cmd]);

  useEffect(() => {
    if (Array.isArray(cmd?.bloquages)) {
      let tmp = cmd?.bloquages?.filter((el) => el?.status != 'resolus')?.map((el) => el?.type);
      tmp = [...new Set(tmp)];
      set_blocage_tags(tmp);
    }
  }, [cmd?.bloquages]);
  return (
    <>
      <TableRow hover>
        <TableCell>
          <IconButton color="error" onClick={(e) => onDelItem(cmd?.idCmdFournisseur)}>
            <FeatherIcon icon="trash" width="18" />
          </IconButton>
        </TableCell>
        <TableCell>
          <Typography
            fontWeight={500}
            variant="subtitle2"
            color={'primary.main'}
            onClick={(e) => onItemClick(cmd)}
            sx={{ textDecoration: 'underline', cursor: 'pointer' }}
          >
            {cmd?.ref}
            <span style={{ display: 'block' }}>{cmd?.ref_monday}</span>
            {cmd?.is_urgent && (
              <Chip
                color="error"
                sx={{ pl: 0, borderRadius: '100%', borderRadius: 1, float: 'right' }}
                size="small"
                label={
                  <Icon fontSize="small">
                    <WhatshotIcon />
                  </Icon>
                }
              />
            )}
            {Array.isArray(blocage_tags) &&
              blocage_tags?.map((el) => (
                <Chip
                  color="error"
                  sx={{ pl: 0, borderRadius: 1, borderRadius: 1, mr: '2px', mt: '1px' }}
                  size="small"
                  label={`! ${el}`}
                />
              ))}
            {is_retard && (
              <Chip
                color="error"
                sx={{
                  borderRadius: 1,
                  mr: '2px',
                  mt: '1px',
                  display: 'block',
                  textAlign: 'center',
                }}
                size="small"
                label={`Retard (${Math.abs(+nbr_j_retard)} J)`}
              />
            )}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography fontWeight={500} variant="h6">
            {`${cmd?.catalogue?.nom} ${
              cmd?.catalogue?.groupe_model?.name
                ? `(${cmd?.catalogue?.groupe_model?.name} ${cmd?.catalogue?.groupe_model_var})`
                : ''
            }`}
          </Typography>
          <Typography fontWeight={600} variant="h6" color={'success.main'}>
            {cmd?.catalogue?.sku}
          </Typography>
        </TableCell>

        <TableCell sx={{ backgroundColor: cmd?.fournisseur?.bg_color || 'gray', color: '#fff' }}>
          <Typography fontWeight={500} variant="subtitle2" textAlign={'center'}>
            {cmd?.client ? `${cmd?.client?.nom} ${cmd?.client?.prenom}` : ''}
          </Typography>
        </TableCell>

        <TableCell>
          <Typography fontWeight={500} variant="subtitle2" textAlign={'center'}>
            {cmd?.fournisseur?.nomSociete || '-'}
          </Typography>
        </TableCell>

        <TableCell>
          <Chip
            variant="outlined"
            label={cmd?.status || '---'}
            sx={{
              borderColor: CmdFbStatusBg?.[cmd?.status] ? CmdFbStatusBg?.[cmd?.status] : 'gray',
              color: CmdFbStatusBg?.[cmd?.status] ? CmdFbStatusBg?.[cmd?.status] : '#fff',
              borderRadius: 1,
              px: 3,
              height: '24px',
              textTransform: 'capitalize',
            }}
          />
        </TableCell>

        <TableCell>
          <Typography fontWeight={500} variant="subtitle2">
            {cmd?.is_urgent && cmd?.date_urgent
              ? String(cmd?.date_urgent).slice(0, 10)
              : cmd?.date_livraison_prevu
                ? String(cmd?.date_livraison_prevu).slice(0, 10)
                : '-'}
          </Typography>
        </TableCell>

        <TableCell
          sx={{
            backgroundColor: cmd?.magasin?.bg_color || 'gray',
            color: cmd?.magasin?.nom ? '#000' : '#fff',
          }}
        >
          <Typography fontWeight={500} variant="subtitle2" textAlign={'center'}>
            {cmd?.magasin?.code || 'central'}
          </Typography>
        </TableCell>
      </TableRow>
    </>
  );
};

export default CmdBulkEditContainer;
